<template>
  <el-row style="background-color: #c6dcec" class="contain">
    <div class="form-head-title">
      <div>
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="form-out-block">
      <div class="form-inner-block">
        <!-- 标题 -->
        <div class="form-title">
          <span>{{ title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="form-remark">
          <div v-html="remark"></div>
        </div>
        <div class="form-seach-block">
          <div>
            <v-form-render
              :form-json="formJson"
              :form-data="formData"
              :option-data="optionData"
              ref="vFormRef"
            >
            </v-form-render>
          </div>
          <!-- 图片 -->
          <!--        <div   v-if="this.imgUrl">-->
          <div  v-if="this.imgUrl" >
            <!--          <el-image   :src="imgserver + imgUrl" fit="fill"></el-image>-->
            <el-image   style="height: 100%; width: 100%"
                        :src="imgserver + this.imgUrl" fit="cover" ></el-image>
          </div>
          <div>
            <div class="search-button-block">
              <el-button type="primary" @click="searchData">搜 索</el-button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="show-table-block">
          <div
            v-for="(item, index) in fullShowTableData"
            class="table-result-card"
            :key="index"
          >
            <v-form-render
              :form-json="{}"
              :form-data="{}"
              :ref="'vShowFormRef' + index"
            ></v-form-render>
          </div>
        </div>
      </div>
    </div>
  </el-row>
</template>

<script>
import {
  findOsFormTemplateInfo,
  findOsFormReport,
} from "@/api/customFormApi.js";
import { Decrypt } from "../utils/screate";
import shareMethods from "@/common/shareMethods";
export default {
  name: "home",
  components: {},
  data() {
    return {
      bannerList: [],
      bannerHeight: 22.9,
      title: "",
      remark: "",
      imgUrl: null,
      formJson: {},
      formData: {},
      optionData: {},
      tmplateId: "",
      fullShowTableData: [],
      showTableDataKeyArray: [],
      showTableData: [],
      showContentArray: [],
      showTempateArray: [],
      mobiePhoneShow: true,
    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = "https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = "长沙市唯上商务科技学校";
    let title = "长沙市唯上商务科技学校";
    this.share(imgUrl, linkUrl,desc, title );

    this.tmplateId = Decrypt(this.$route.query.id);
    findOsFormTemplateInfo(this.tmplateId).then((res) => {
      if (res.code == 200) {
        this.formTemplate = res.data;
        this.fillFormJson = JSON.parse(res.data.content.replace(/"required":true/g, '"required":false'));

        console.log("this.fillFormJson",res.data.content.replace(/"required":true/g, '"required":false') )

        this.title = res.data.name;
        this.imgUrl = res.data.imgUrl;
        this.remark = this.dealRemark(res.data.remark);
        this.showContentArray = JSON.parse(res.data.showContent.replace(/"required":true/g, '"required":false'));
        var tmpSearchFormObj = JSON.parse(res.data.content.replace(/"required":true/g, '"required":false'));
        tmpSearchFormObj.widgetList = JSON.parse(res.data.queryContent.replace(/"required":true/g, '"required":false'));
        setTimeout(() => {
          this.$refs.vFormRef.setFormJson(tmpSearchFormObj);
        });
      }
    });

    this.handleResize();
  },
  methods: {
    dealRemark(content) {
      var tmpcontents = content;
      // let r = RegExp(/<[(img|iframe)]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      // 获取文本中style部分
      var reg = RegExp(/<iframe\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      var matchres = tmpcontents.match(reg);
      // 获取style部分中width部分
      var widthReg = RegExp(/\bwidth\b\:\s+(.*?)\;/g);
      // 获取style部分中height部分
      var heightReg = RegExp(/\bheight\b\:+\s+(.*?)\;/g);
      // let matchres = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
      var imglength = this.mobiePhoneShow ? "120" : "100";
      if (matchres) {
        matchres.forEach((item, index) => {
          var innnermatchres = item.match(/(style=\")+\s*(.*?)\"/g);
          innnermatchres.forEach((inneritem, index) => {
            var widthMatch = inneritem.match(widthReg);
            var heightMatch = inneritem.match(heightReg);
            if (widthMatch && heightMatch) {
              var realwidth = widthMatch[0].match(/\d+/g);
              var realheight = heightMatch[0].match(/\d+/g);
              var finalheight;
              if (realwidth && realheight) {
                finalheight =
                  (realheight[0] / realwidth[0]) * imglength + "rem";
              }
              let _str =
                'style="width:' +
                imglength +
                "rem !important;height:" +
                finalheight +
                ';text-align:center;"'; //追加之后的img
              tmpcontents = tmpcontents.replace(inneritem, _str);
            }
          });
        });
        // 获取style部分中width部分
      }
      let r = RegExp(/<img\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      let matchresArray = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
      // 判断标签是否含有style，含有替换
      // (?<=<p\s+style=").*(?=">)
      if (matchresArray && matchresArray.length > 0) {
        matchresArray.forEach((item, index) => {
          let len = item.length;
          if (item.indexOf("style") < 0) {
            // 不含style 新增
            let _newStyleStr =
              item.slice(0, len - 2) +
              '" style="max-width: 100%  !important; width: 120rem !important;height:auto !important;text-align:center;"/>'; //追加之后的img
            tmpcontents = tmpcontents.replace(item, _newStyleStr);
          } else {
            var startStyleIndex = item.indexOf("style") + 7;
            var endStyleIndex = item.indexOf('"', startStyleIndex);
            let _styleStr =
              "width:" +
              imglength +
              "rem;max-width: 100%; height:auto !important;text-align:center;";
            // 判断标签是否含有style，含有替换
            tmpcontents = tmpcontents.replace(
              item.slice(startStyleIndex, endStyleIndex),
              _styleStr
            );
          }
        });
      }

      let tableReg = RegExp(/<table\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
      let tableMatchresArray = tmpcontents.match(tableReg); //返回数组['<img ... />','<img ... />']
      if (tableMatchresArray && tableMatchresArray.length > 0) {
        tableMatchresArray.forEach((item, index) => {
          let len = item.length;
          if (item.indexOf("style") < 0) {
            // 不含style 新增
            let _newStyleStr =
              item.slice(0, len - 2) +
              '" style="max-width: 100%  !important; width: 120rem !important;height:auto !important;text-align:center;"/>'; //追加之后的img
            tmpcontents = tmpcontents.replace(item, _newStyleStr);
          } else {
            var startStyleIndex = item.indexOf("style") + 7;
            var endStyleIndex = item.indexOf('"', startStyleIndex);
            let _styleStr =
              "width:" +
              imglength +
              "rem;max-width: 100%; height:auto !important;text-align:center;";
            // 判断标签是否含有style，含有替换
            tmpcontents = tmpcontents.replace(
              item.slice(startStyleIndex, endStyleIndex),
              _styleStr
            );
          }
        });
      }
      return tmpcontents;
    },

    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      // 这里的750是指设计图的大小,自己根据实际情况改变
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      this.mobiePhoneShow = oWidth < 768 ? true : false;
      var screenWidth = window.innerWidth;
    },

    searchData() {
      this.showTableDataKeyArray = [];
      this.$refs.vFormRef
        .getFormData()
        .then((formData) => {
          var tmpObj = {};
          for (let index in formData) {
            if (formData[index] !== "") {
              tmpObj[index] = formData[index];
            }
          }
          findOsFormReport({
            templateId: this.tmplateId,
            queryContent: JSON.stringify(tmpObj),
          }).then((res) => {
            if (res.code == 200) {
              if (this.showContentArray.length > 0) {
                var tmpSearchFormObj = this.fillFormJson;
                tmpSearchFormObj.widgetList = this.showContentArray;
                // 展示数组模板
                this.fullShowTableData = res.rows;
                this.fullShowTableData.forEach((item, index) => {

                  console.log("item", item);

                  // 遍历并展示数据
                  var refName = "vShowFormRef" + index;
                  setTimeout(() => {
                    this.$refs[refName][index].setFormJson(tmpSearchFormObj);
                    this.$nextTick(() => {
                      this.$refs[refName][index].setFormData(
                        JSON.parse(item.content)
                      );
                      this.$refs[refName][index].disableForm();
                    });
                  });
                });

                // for (let index in this.showContentArray) {
                //   tmpShowTableDataKeyArray.push({
                //     label: this.showContentArray[index].label,
                //     name: this.showContentArray[index].options.name,
                //   });
                // }
                // this.showTableDataKeyArray = tmpShowTableDataKeyArray;
                // this.fullShowTableData = res.rows;
                // res.rows.forEach((item, index) => {
                //   var tmpContentObj = JSON.parse(item.content);
                //   tmpShowDataTable.push({
                //     ...tmpContentObj,
                //     id: item.id,
                //     formTemplate: item.formTemplate,
                //   });
                // });
                // this.showTableData = tmpShowDataTable;
              } else {
                // 展示数组模板
                this.fullShowTableData = res.rows;
                this.fullShowTableData.forEach((item, index) => {
                  // 遍历并展示数据
                  var refName = "vShowFormRef" + index;
                  setTimeout(() => {
                    this.$refs[refName][index].setFormJson(this.fillFormJson);
                    this.$nextTick(() => {
                      this.$refs[refName][index].setFormData(
                        JSON.parse(item.content)
                      );
                      this.$refs[refName][index].disableForm();
                    });
                  });
                });
              }

              var resultMsg = "查询成功!";
              if (this.fullShowTableData.length == 0) {
                resultMsg = "未查询到数据。";
              }
              this.$message({
                type: "success",
                message: resultMsg,
              });
            }
          });
        })
        .catch((error) => {
          // Form Validation failed
          this.$message.error(error);
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getFuncList();
    next((vm) => {});
  },
  computed: {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.contain {
  min-height: 100vh;
}
.form-head-title {
  height: 44px;
  background-color: #255077;
  div {
    height: 24px;
    margin: 0 0 0 30px;
    padding: 10px 0;
    span {
      font-size: 18px;
      height: 24px;
      line-height: 24px;
      color: #ffffff;
      font-weight: bold;
    }
  }
}
.form-out-block {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  justify-content: center;
  align-items: center;
  .form-inner-block {
    border-radius: 20px;
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    padding-bottom: 20px;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 80rem;
    .form-title {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 30px;
      span {
        width: 80rem;
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        color: #050d33;
      }
    }
    .form-remark {
      padding: 0 20px;
      margin: 20px 0;
      width: 600px;
      font-size: 24px;
    }

    .form-seach-block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 400px;
      ::v-deep .el-form-item {
        display: flex;
        flex-direction: row;
        width: 400px;
        .el-form-item__label {
          width: 180px !important;
        }
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
      .search-button-block {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .el-button {
          width: 180px;
          height: 50px;
          font-size: 18px;
        }
      }
    }
    .form-button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 20px;
      .el-button {
        width: 180px;
        height: 50px;
      }
    }
  }

  .show-table-block {
    margin-top: 30px;
    .table-result-card {
      width: 80rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      margin-top: 10px;
      padding: 20px 20px;
      box-sizing: border-box;

      :deep(.el-form-item__label){
        width: 160px !important;
      }

      :deep(.el-form-item__content){
        margin-left: 160px !important;
      }

      .table-result-item {
        width: 40rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        margin: 12px 0;
        .item-title {
          width: 12rem;
          text-align: center;
          height: 35px;
          line-height: 35px;
          box-sizing: border-box;
          font-size: 14px;
        }
        .item-content {
          width: 28rem;
          height: 35px;
          line-height: 35px;
          text-align: start;
          box-sizing: border-box;
          border: 1px solid #f0f1f4;
          border-radius: 4px;
          padding-left: 10px;
          font-size: 14px;
          color: #c0c4cc;
          overflow: hidden;
          background-color: #f5f7fa;
        }
      }


      :deep(.is-checked){
        .el-checkbox__inner{
          background-color: #409EFF;
        }
        .el-checkbox__label{
          color: #409EFF;
        }
      }

      :deep(.el-input){
        .el-input__inner{
          color: #409EFF !important;
        }
      }

      :deep(.el-radio ){
        &.is-checked{
          .el-radio__inner{
            border-color: #409EFF !important;
            background: #409EFF !important;
          }
          .el-radio__label{
            color: #409EFF !important;
          }
        }
      }

      :deep(.el-textarea){
        .el-textarea__inner{
         color: #409EFF !important;
        }
      }

    }

  }
}

.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {
}

@media only screen and (max-width: 1439px) {
  .background-image {
    width: 100%;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 0 auto;
    height: 100%; /* 设置div的高度 */
  }
}
@media only screen and (max-width: 1330px) {
}
@media only screen and (max-width: 1200px) {
  .form-out-block {
    .form-inner-block {
      .form-remark {
        padding: 0 20px;
        margin-top: 20px;
        width: 76rem;
      }
    }
  }
}
@media only screen and (max-width: 992px) {
  .form-out-block {
    .form-inner-block {
      .form-title {
        span {
          font-size: 20px;
        }
      }

      .form-remark {
        font-size: 16px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {

  .form-head-title {
    div {
      width: 100%;
      height: 24px;
      display: flex;
      margin: 0;
      padding-left: 30px;
      box-sizing: border-box;

      span {

        font-size: 18px;
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 24px;
        color: #ffffff;
        font-weight: bold;
      }
    }
  }

  .form-out-block {
    .form-inner-block {
      width: 140rem;
      .form-block {
        margin-left: 20px;
        width: 140rem;
      }
      .form-remark {
        padding: 0 20px;
        width: 120rem;
      }
      .form-seach-block {
        width: 120rem;
        ::v-deep .el-form-item {
          width: 100rem;
          .el-form-item__label {
            width: 80px !important;
            //width:132px !important;
          }
          .el-form-item__content {
            margin-left: 10px !important;
          }
          ::v-deep .el-radio {
            margin-right: 0px;
          }
        }
        .search-button-block {
          .el-button {
            width: 120px;
            height: 40px;
            font-size: 14px !important;
          }
        }
      }

      .form-title {
        width: 100%;
        span {
          width: 85%;
        }
      }

    }
    .show-table-block {
      .table-result-card {
        width: 140rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        margin-top: 10px;
        padding: 20px 20px;
        box-sizing: border-box;


        :deep(.el-form-item__label){
          width: auto !important;
        }

        :deep(.el-form-item__content){
          margin-left: auto !important;
        }

        .table-result-item {
          width: 140rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin: 12px 0;
          .item-title {
            min-width: 30rem;
          }
          .item-content {
            width: 90rem;
          }
        }
      }
    }
  }
  .show-table-block {
    margin-top: 30px;
    ::v-deep .el-form-item {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .el-form-item__label {
        min-width: 80px !important;
        //width: 132px !important;
        text-align: start;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        width: 80rem;
        text-align: center;
      }
    }
    .search-button-block {
      .el-button {
        width: 120px;
        height: 40px;
        font-size: 14px !important;
      }
    }
  }
}
@media only screen and (max-width: 520px) {
  .form-out-block {
    .form-inner-block {
      .form-title {
        span {
          font-size: 16px;
        }
      }

      .form-remark {
        font-size: 12px;
      }
    }
  }

  .show-table-block {
    margin-top: 30px;
    ::v-deep .el-form-item {
      .el-form-item__content {
        width: 136rem;
      }
    }
  }
}


</style>
